{
  "core.email": "Netfang",
  "core.name": "Nafn",
  "core.or": "eða",
  "core.and": "og",
  "core.cancel": "Hætta við",
  "core.confirm": "Staðfesta",
  "core.save": "Vista",
  "core.edit": "Breyta",
  "core.duplicate": "Afrita",
  "core.delete": "Eyða",
  "core.remove": "Eyða",
  "core.rename": "Endurnefna",
  "core.yes": "Já",
  "core.no": "Nei",
  "core.back": "Til baka",
  "core.continue": "Halda áfram",
  "core.close": "Loka",
  "core.search": "Leita",
  "core.password": "Lykilorð",
  "core.add": "Bæta við",
  "core.view": "Skoða",
  "core.update": "Uppfæra",
  "core.filter": "Sía",
  "core.preview": "Skoða",
  "core.open": "Opna",
  "core.learnMore": "Skoða nánar",
  "core.fileConverting": "Verið er að vinna úr skránni fyrir forskoðun",
  "core.user": "Notandi",
  "core.active": "Virk",
  "core.jqQuery": "./jq Query",

  "core.comparator.is": "Er...",
  "core.comparator.not_is": "Er ekki...",
  "core.comparator.any_of": "Er eitthvað af...",
  "core.comparator.none_of": "Er ekkert af...",
  "core.comparator.after": "Eftir",
  "core.comparator.on": "Þann",
  "core.comparator.before": "Fyrir",

  "core.comparator.starts": "Byrjar á...",
  "core.comparator.not_starts": "Byrjar ekki á...",
  "core.comparator.contains": "Inniheldur",
  "core.comparator.not_contains": "Inniheldur ekki",
  "core.comparator.is_rated_by": "Hefur gefið einkunn...",
  "core.comparator.not_is_rated_by": "Hefur ekki gefið einkunn...",
  "core.comparator.is_none": "Engin einkunn",
  "core.comparator.today": "Í dag",
  "core.comparator.yesterday": "Í gær",
  "core.comparator.is_empty": "Er tómt",
  "core.comparator.is_not_empty": "Er ekki tómt",
  "core.comparator.gt": "Meira en",
  "core.comparator.between": "Milli",
  "core.comparator.eq": "Nákvæmlega",
  "core.comparator.lt": "Minna en",
  "core.comparator.empty": "Án gildis",
  "core.comparator.not_empty": "Hefur gildi",
  "core.comparator.contains_multi": "Inniheldur",

  "core.errors.generic": "Eitthvað fór úrskeiðis. Vinsamlegast hafðu samband við 50skills.",

  "core.language.en": "Enska",
  "core.language.is": "Íslenska",
  "core.language.pl": "Pólska",
  "core.language.no": "Norska",
  "core.language.sv": "Sænska",
  "core.language.fr": "Franska"
}
